import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import styles from './VocabularWord.module.scss';
import classNames from 'classnames';

export default class VocabularWord extends Component {
    static propTypes = {
        word: PropTypes.string,
    };

    render() {
        const {word} = this.props;
        const renderContent = this.props.children;

        return (
            <span className={styles.word}>
                {this.renderHiglightedWord(word)}
                <div className={styles.popup}>
                    <div className={styles.popupBackground}>
                        {renderContent(this.renderHiglightedWord)}
                    </div>
                </div>
            </span>
        );
    }

    renderHiglightedWord = word => {
        return <span className={styles.highlight}>{word}</span>;
    };
}
